import createPalette from '@mui/material/styles/createPalette'

const palette = createPalette({
  mode: 'dark',

  primary: {
    main: '#FFFFFF',
    dark: '#000000',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#E21222',
    dark: '#000000',
    contrastText: '#fff',
  },

  error: { main: '#E21222' },
  warning: { main: '#E75415' },
  info: { main: '#123A6B' },
  success: { main: '#287C48' },

  background: {
    paper: '#fff',
    default: '#144C89',
  },

  text: {
    primary: '#FFFFFF',
    secondary: '#BABABA',
    disabled: 'rgba(46, 52, 66, .5)',
  },

  action: {
    active: '#81B728',
    hover: '#81B728',
    focus: '#81B728',
    selected: '#81B728',
    disabled: '#6C6C6C',
    disabledBackground: 'rgba(120,120,120, .7)',
  },

  divider: 'rgba(18, 58, 107, .25)',
})

export default palette
